interface AddDaysToDateOptions {
  /**
   * the date to add days to. if a string is provided, it will be wrapped in the Date constructor
   */
  date?: Date | string | number | null
  /**
   * the number of days to add to the date
   */
  numDays: number
}

/**
 * Adds a number of days to the supplied date. returns undefined for undefined dates
 */
export const addDaysToDate = ({
  numDays,
  date,
}: AddDaysToDateOptions): Date | undefined => {
  let _date = date
  if (!_date) return undefined
  if (typeof _date === 'string') _date = new Date(_date)
  if (typeof _date === 'number') _date = new Date(_date)

  const time = _date.getTime()
  const timeToAdd = numDays * (1000 * 60 * 60 * 24)
  const targetTime = time + timeToAdd

  return new Date(targetTime)
}
